var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.total > 1
    ? _c(
        "div",
        { staticClass: "pagination" },
        [
          _vm.page > 1
            ? _c(
                "div",
                {
                  staticClass: "page prev prev-arrow",
                  on: {
                    click: function ($event) {
                      return _vm.goToPage(1)
                    },
                  },
                },
                [_c("span", { staticClass: "fa fa-angle-double-left" })]
              )
            : _vm._e(),
          _vm._l(_vm.backPages, function (i) {
            return _c(
              "div",
              {
                staticClass: "page prev",
                on: {
                  click: function ($event) {
                    return _vm.goToPage(i)
                  },
                },
              },
              [_vm._v(_vm._s(i))]
            )
          }),
          _c("div", { staticClass: "page active" }, [
            _vm._v(_vm._s(this.page)),
          ]),
          _vm._l(_vm.nextPages, function (i) {
            return _c(
              "div",
              {
                staticClass: "page next",
                on: {
                  click: function ($event) {
                    return _vm.goToPage(i)
                  },
                },
              },
              [_vm._v(_vm._s(i))]
            )
          }),
          _vm.page < _vm.total
            ? _c(
                "div",
                {
                  staticClass: "page next next-arrow",
                  on: {
                    click: function ($event) {
                      return _vm.goToPage(_vm.total)
                    },
                  },
                },
                [_c("span", { staticClass: "fa fa-angle-double-right" })]
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }